import CloseIcon from '@mui/icons-material/Close'
import { Alert, Collapse, IconButton } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

const AlertMessage = ({ action, type, message, ...others }) => {
  const [open, setOpen] = React.useState(true)
  return (
    <div>
      <Collapse in={open}>
        <Alert
          severity={type}
          variant="filled"
          {...others}
          action={
            action && (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpen(false)
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            )
          }
        >
          <span>{message}</span>
        </Alert>
      </Collapse>
    </div>
  )
}

export default AlertMessage

AlertMessage.propTypes = {
  action: PropTypes.bool,
  type: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  variant: PropTypes.oneOf(['outlined', 'filled']),
  message: PropTypes.any,
}
